/**
 * Umumiy kimyo (bench) laboratoriya ishlari reyestri. Ta'riflar domain pack'lardan keladi
 * (`packs/<id>/labs/*.json`, `kind: "bench"`) — engine faylga havola qilmaydi.
 */
import type { BenchLab } from '../schema';

/** Yuklangan bench lablari (pack'lar ro'yxatga olingan tartibda) */
export const benchLabs: BenchLab[] = [];

export function registerBenchLabs(labs: readonly BenchLab[]): void {
  for (const lab of labs) {
    const i = benchLabs.findIndex((l) => l.id === lab.id);
    if (i >= 0) benchLabs[i] = lab;
    else benchLabs.push(lab);
  }
}

export function getBenchLab(id: string): BenchLab {
  const lab = benchLabs.find((l) => l.id === id);
  if (!lab) throw new Error(`Unknown bench lab: ${id}`);
  return lab;
}

export function hasBenchLab(id: string): boolean {
  return benchLabs.some((l) => l.id === id);
}

export function benchLabIds(): string[] {
  return benchLabs.map((l) => l.id);
}
